import script from "./IntegrationsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegrationsPanel.vue?vue&type=script&setup=true&lang=js"

import "./IntegrationsPanel.vue?vue&type=style&index=0&id=3c3eb036&lang=scss"

const __exports__ = script;

export default __exports__